var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import UploadFilesButton from 'components/Buttons/UploadFilesButton';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
var CreateActivityManualAttachments = function (_a) {
    var loadingFiles = _a.loadingFiles, setLoadingFiles = _a.setLoadingFiles;
    var t = useTranslation().t;
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-10 pt-10" }, { children: [_jsx("p", __assign({ className: "font-semibold dark:text-white" }, { children: t('Добавить вложение') }), void 0), _jsx("p", __assign({ className: "text-13 text-grey" }, { children: t('createAcitivityManualFormFileAttachmentsHelper') }), void 0), _jsxs("div", __assign({ className: "flex flex-col space-y-10 items-center" }, { children: [_jsx(UploadFilesButton, { setLoadingFiles: setLoadingFiles, accept: "image/*", multiple: true, maxFiles: 5 }, void 0), _jsx("p", __assign({ className: "text-grey text-12" }, { children: t('Максимум 5 файлов') }), void 0)] }), void 0)] }), void 0), loadingFiles && (loadingFiles === null || loadingFiles === void 0 ? void 0 : loadingFiles.length) > 0 && (_jsx(_Fragment, { children: Array.from(loadingFiles).map(function (file, i) {
                    return (_jsxs("div", __assign({ className: "flex flex-row space-x-5 items-center" }, { children: [_jsx("p", __assign({ className: "dark:text-white" }, { children: file.name }), void 0), _jsx(IconButton, __assign({ "aria-label": "expand row", size: "small", onClick: function () {
                                    var files = Array.from(loadingFiles);
                                    _.pullAt(files, [i]);
                                    setLoadingFiles(files);
                                } }, { children: _jsx(DeleteIcon, {}, void 0) }), void 0)] }), i));
                }) }, void 0))] }, void 0));
};
export default CreateActivityManualAttachments;
